/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateDocument,
    CandidateDocumentFromJSON,
    CandidateDocumentFromJSONTyped,
    CandidateDocumentToJSON,
    CandidateLetter,
    CandidateLetterFromJSON,
    CandidateLetterFromJSONTyped,
    CandidateLetterToJSON,
    CandidateLink,
    CandidateLinkFromJSON,
    CandidateLinkFromJSONTyped,
    CandidateLinkToJSON,
} from './';

/**
 * [P_A_21] [P_A_22]
 * @export
 * @interface CandidateCandidate
 */
export interface CandidateCandidate {
    /**
     * 
     * @type {number}
     * @memberof CandidateCandidate
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateCandidate
     */
    hasFilledCv?: boolean;
    /**
     * 
     * @type {CandidateDocument}
     * @memberof CandidateCandidate
     */
    document?: CandidateDocument;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateCandidate
     */
    acceptPrivacyPolicy?: boolean;
    /**
     * 
     * @type {Array<CandidateLink>}
     * @memberof CandidateCandidate
     */
    links?: Array<CandidateLink>;
    /**
     * 
     * @type {Array<CandidateLetter>}
     * @memberof CandidateCandidate
     */
    letters?: Array<CandidateLetter>;
}

export function CandidateCandidateFromJSON(json: any): CandidateCandidate {
    return CandidateCandidateFromJSONTyped(json, false);
}

export function CandidateCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateCandidate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'hasFilledCv': !exists(json, 'has_filled_cv') ? undefined : json['has_filled_cv'],
        'document': !exists(json, 'document') ? undefined : CandidateDocumentFromJSON(json['document']),
        'acceptPrivacyPolicy': !exists(json, 'accept_privacy_policy') ? undefined : json['accept_privacy_policy'],
        'links': !exists(json, 'links') ? undefined : ((json['links'] as Array<any>).map(CandidateLinkFromJSON)),
        'letters': !exists(json, 'letters') ? undefined : ((json['letters'] as Array<any>).map(CandidateLetterFromJSON)),
    };
}

export function CandidateCandidateToJSON(value?: CandidateCandidate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'has_filled_cv': value.hasFilledCv,
        'document': CandidateDocumentToJSON(value.document),
        'accept_privacy_policy': value.acceptPrivacyPolicy,
        'links': value.links === undefined ? undefined : ((value.links as Array<any>).map(CandidateLinkToJSON)),
        'letters': value.letters === undefined ? undefined : ((value.letters as Array<any>).map(CandidateLetterToJSON)),
    };
}


